import { render, staticRenderFns } from "./KanbanSummary.vue?vue&type=template&id=7bb9f938&scoped=true"
import script from "./KanbanSummary.vue?vue&type=script&lang=js"
export * from "./KanbanSummary.vue?vue&type=script&lang=js"
import style0 from "./KanbanSummary.vue?vue&type=style&index=0&id=7bb9f938&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb9f938",
  null
  
)

export default component.exports